export default __webpack_public_path__ + "motor-dark.svg";